import React from 'react';
import { Col, Descriptions, Form, Row, Table, Typography, Upload } from 'antd';
import { useTranslation } from 'react-i18next';
import { InboxOutlined } from '@ant-design/icons';
import FormHelper from '../../../../../../../helpers/FormHelper';

const dataSource = [
  {
    key: '1',
    name: '2021-04-14',
    age: 'feriale',
    address: 'Test',
  },
  {
    key: '2',
    name: '2021-04-15',
    age: 'chiusura',
    address: 'Test2',
  },
  {
    key: '3',
    name: '2021-04-16',
    age: 'festivo',
    address: 'Test3',
  },
  {
    key: '4',
    name: '2021-04-17',
    age: 'prefestivo',
    address: 'Test4',
  },
];

const columns = [
  {
    title: 'Day',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Day type',
    dataIndex: 'age',
    key: 'age',
  },
  {
    title: 'TRADING CALENDAR',
    dataIndex: 'address',
    key: 'address',
  },
];

const FileSection = () => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Allegato')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item label='Dragger' labelAlign={'left'}>
          <Form.Item
            name='file'
            valuePropName='fileList'
            getValueFromEvent={FormHelper.normFile}
            noStyle
            multiple={false}
          >
            <Upload.Dragger
              multiple={false}
              name='file'
              beforeUpload={FormHelper.beforeUpload}
            >
              <p className='ant-upload-drag-icon'>
                <InboxOutlined />
              </p>
              <p className='ant-upload-text'>
                {t('Click or drag file to this area to upload')}
              </p>
            </Upload.Dragger>
          </Form.Item>
        </Form.Item>
      </Col>
      <Col span={9} />
      <Col span={6}>
        <Typography.Title level={3}>{t('Example')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Table pagination={false} dataSource={dataSource} columns={columns} />;
      </Col>
    </Row>
  );
};

export default React.memo(FileSection);
